import * as types from '../constants';
import initialState from '../initialState';

export default function reducer(state = initialState.organization, action) {
  const { type, payload } = action;
  switch (type) {
    case types.GET_ORGANIZATION_DETAILS_SUCCESS:
      return {
        ...state,
        details: payload.details,
      };
    case types.GET_ORGANIZATION_MEMBERS_SUCCESS:
      return {
        ...state,
        members: payload.members,
        totalMembersCount: payload.totalMembersCount,
      };
    case types.GET_ORGANIZATION_ADMINS_SUCCESS:
      return {
        ...state,
        admins: payload.admins,
        totalAdminsCount: payload.totalAdminsCount,
      };
    case types.DELETE_ORGANIZATION_MEMBER_SUCCESS:
      return {
        ...state,
        members: state.members.filter(({ id }) => id !== payload.id),
        totalMembersCount: state.totalMembersCount - 1,
      };
    case types.DELETE_ORGANIZATION_ADMIN_SUCCESS:
      return {
        ...state,
        admins: state.admins.filter(({ id }) => id !== payload.id),
        totalAdminsCount: state.totalAdminsCount - 1,
      };
    case types.GET_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        organizations: payload.organizations,
        totalCount: payload.totalCount,
      };
    case types.DELETE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        organizations: state.organizations.filter(
          ({ id }) => id !== payload.id
        ),
        totalCount: state.totalCount - 1,
      };
    case types.GET_CONNECTED_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        connectedOrganizations: payload.connectedOrganizations,
        connectedOrganizationsTotalCount: payload.totalCount,
      };
    case types.ADD_CONNECTED_ORGANIZATION_SUCCESS:
      return {
        ...state,
        connectedOrganizations: [
          ...state.connectedOrganizations,
          ...payload.connectedOrganizations,
        ],
        connectedOrganizationsTotalCount:
          state.connectedOrganizationsTotalCount +
          payload.connectedOrganizations.length,
      };
    case types.DELETE_CONNECTED_ORGANIZATION_SUCCESS:
      return {
        ...state,
        connectedOrganizations: state.connectedOrganizations.filter(
          ({ id }) => id !== payload.id
        ),
        connectedOrganizationsTotalCount:
          state.connectedOrganizationsTotalCount - 1,
      };
    default:
      return state;
  }
}
